export default __webpack_public_path__ + "img/26831df65040b84a7327f2430a9d456d.svg";